import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcDrawer } from '@one/react';

export type PocDrawerProps = ComponentPropsWithoutRef<typeof OwcDrawer>;

export const PocDrawer = forwardRef<ElementRef<typeof OwcDrawer>, PocDrawerProps>((props, ref) => (
    <OwcDrawer ref={ref} {...props} />
));

PocDrawer.displayName = 'PocDrawer';
